import { flattenObject } from "@global/Utilities/flattenObject";
import { router } from "@inertiajs/vue3";
import { useOverviewStore } from "../overviewStore";
import type { SearchDTO } from "../types";
import { getDefinedParams } from "./getDefinedParams";
import { moveMapPosition } from "./moveMapPosition";

type Props = {
    url: string;
    params?: Partial<SearchDTO>;
    replace?: boolean;
    preserveScroll?: boolean;
    only?: string[];
};

// Replace the map with the given parameters
// This function is used to update the map when the user navigates to a new page
export const updateMapReplace = ({ url, params = {}, replace = true, preserveScroll, only = ["data", "search", "errors", "markers", "cards"] }: Props) => {
    const overviewStore = useOverviewStore();
    return new Promise<void>((resolve, reject) => {
        // Check if the overview page was active before the navigation
        const wasOverviewPageActive = overviewStore.isOverviewPageActive;
        router.visit(new URL(url, window.location.origin).href, {
            preserveState: true,
            preserveScroll,
            only,
            showProgress: !overviewStore.isOverviewPageActive,
            replace: overviewStore.isOverviewPageActive ? replace : false,
            data: getDefinedParams(flattenObject(params)),
            onStart: () => overviewStore.setIsProcessingMap(true),
            onSuccess: async (e) => {
                overviewStore.setIsProcessingMap(false);
                const searchData = e.props.search as Domain.Overview.DataTransferObjects.SearchDTO;
                // Move the map position based on the parameters
                moveMapPosition({ params: searchData, animate: wasOverviewPageActive });
                // Resolve the promise after the map data has been fetched
                resolve();
            },
            onCancel: () => {
                overviewStore.setIsProcessingMap(false);
                resolve();
            },
            onError: (error) => {
                overviewStore.setIsProcessingMap(false);
                reject(error);
            },
        });
    });
};
